<template>
  <div class="jobs row">
    <div class="col-12">
      <Hero
        title="Aqui, sua <span>carreira</span><br />acontece"
        image="banner-vagas.png"
        layout="md"
        :search="false"
      />

      <div class="row tittle">
        <h1>Pesquise por <strong>vagas de emprego</strong></h1>
      </div>

      <div class="row" id="oportunidades">
        <div class="col-10 mx-auto mb-5">
          <Jobs :key="$route.fullPath" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hero from "@/components/media/Hero.vue";
import Jobs from "@/components/jobs/Jobs.vue";
import Slider from "@/components/Slider.vue";

export default {
  name: "JobsList",

  data() {
    return {
    };
  },

  computed: {
    selectedTeam(){
      return this.$route.query.collection || null;
    },

    teamInfos() {
      return (
        this.$store.state.teams.find(
          (team) => team.slug == this.selectedTeam
        ) || {}
      );
    },
  },

  components: {
    Hero,
    Jobs,
    Slider,
  },
};
</script>

<style lang="scss" scoped>
  /deep/ .hero {
    .text{
      min-width: 60%;
      align-self: flex-start;
      margin-left: 100px;

       @include media-breakpoint-down(md){
        width: 100%;
        margin-left: auto;
        margin-right: auto;
      }
    }
  }

  .jobs{
    background: #F5F5F5;
  }

  .tittle{
    background-color: #0A1D6F;
    justify-content: center;
    padding: 13px 0;
    margin-bottom: 40px;

    h1{
      font-size: 36px;
      font-family: 'Bw Gradual DEMO';
      color: #fff;
      font-weight: 300;
    }

    strong{
      color: #57FFFF;
    }

    @media (max-width: 600px){
      padding: 13px 10px;

      h1{
        font-size: 28px;
      }
    }
  }
</style>
